export default __webpack_public_path__ + "static/media/automaint1.fcd24a8b.jpg";